<template>
    <div class="card">
        <div class="card-content">
            <div>
                <h3 class="title">
                    <a :href=this.url class="text-black">
                        {{this.activity.name}}
                    </a>
                </h3>
                <p class="description">
                    {{this.activity.description}}
                </p>
            </div>
            <div class="float-right pt-8">
                <button v-if="!activity.is_booked && activity.is_bookable" @click="register" class="btn btn-primary">
                    Varaa
                </button>
                <button v-if="activity.is_booked && activity.is_bookable" @click="register"
                        class="btn btn-danger btn-block">
                    Peruuta
                </button>
                <button v-if="!activity.is_bookable" disabled="disabled" class="btn btn-warning btn-block">Ei
                    varattavissa
                </button>
            </div>
            <div class="meta">
                <i class="glyphicon glyphicon-user"></i>
                {{ this.activity.bookings + '/' + this.activity.bookings_limit }}
                <br>
                <i class="glyphicon glyphicon-tag"></i>
                {{ activityType }}
                <br>
                <div v-if="activity.type !== 'ongoing'">
                    <i class="glyphicon glyphicon-calendar"></i>
                    {{ formattedDatetime }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import moment from 'moment'
    import Swal from 'sweetalert2/dist/sweetalert2.js'

    export default {
        name: "ActivityCard",
        data: function () {
            return {
                pivot: moment(),
                url: "/activities/" + this.activity.id + "/" + this.activity.slug
            }
        },
        props: {
            activity: {
                type: Object,
                default: function () {
                    return {
                        name: '',
                        description: '',
                        activity_type: '',
                        id: '',
                        datetime: '',
                        bookings: 0,
                        bookings_limit: 0,
                        type: '',
                        is_bookable: true,
                        is_booked: true,
                        slug: ''
                    }
                }
            }
        },
        methods: {
            register: function () {
                if (this.isFullyBooked()) {
                    Swal.fire({
                        type: 'error',
                        title: 'Aktiviteetti täynnä!',
                        text: 'Aktiviteetissa on jo maksimimäärä osallistujia.',
                    })
                }
                axios.post('/api/activities/register/' + this.activity.id, {
                    'activity_date': this.activity.datetime
                }).then(() => {
                    this.renderChanges()
                }).catch(error => {
                        Swal.fire({
                            type: 'error',
                            title: 'Jokin meni pieleen.',
                            text: 'Yritä hetken kuluttua uudelleen.',
                        })
                    }
                )
            },

            isFullyBooked: function () {
                if (this.activity.bookings >= this.activity.bookings_limit) {
                    return true;
                }
                return false;
            },

            renderChanges() {
                if (this.activity.is_booked === false) {
                    this.activity.is_booked = true
                    this.activity.bookings += 1
                } else {
                    this.activity.is_booked = false
                    this.activity.bookings -= 1
                }
            }
        },
        computed: {
            activityType() {
                if (this.activity.type == 'one_time') {
                    return 'Kertaluontoinen'
                }
                if (this.activity.type == 'recurring') {
                    return 'Viikottainen'
                } else {
                    return 'Jatkuva'
                }
            },

            formattedDatetime() {
                return moment.unix(this.activity.datetime).format('YYYY.MM.DD HH:mm');
            }
        },
    }
</script>

<style scoped>
    .card {
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.8);
        height: 13rem;
        margin-bottom: 2rem;

    }

    .description {
        padding-right: 1rem;
        -webkit-line-break: after-white-space;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

    }

    .title {
        padding-right: 1rem;
        -webkit-line-break: after-white-space;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .meta {
        padding-top: 4px;
    }

    .card-content {
        flex: auto;
        padding: 1rem;
    }
</style>
